
import $ from 'jquery';
import { gsap } from 'gsap';

import { Draggable } from 'gsap/Draggable.js';
import { InertiaPlugin } from 'gsap/InertiaPlugin.js';

//this adds a zoom box to the image
let zoomInit = () => {
  gsap.registerPlugin( Draggable, InertiaPlugin );

  let image = document.querySelector('.zoom-image-container img');
  let container = document.querySelector('.zoom-image-container');

  let containerWidth = image.width;
  let containerHeight = image.height;

  let imageWidth  = containerWidth;
  let imageHeight = containerHeight;

  let zoom = {
    value: 1,
    min: 1,
    max: 2,
    step: 0.5,  
    factor: 1.1
  };

  gsap.set(image, { scale: zoom.value, transformOrigin: 'left top' });

  let props = gsap.getProperty(image);

  let draggable = new Draggable( image, {
    cursor: 'grab',
    inertia: true,
    minimumMovement: 5,
    overshootTolerance: 0
  });

  setBounds();
  window.addEventListener( 'resize', resize );
  $( '.zoom-button' ).on( 'click', zoomControls );

  function zoomControls( event ) {

    let oldZoom = zoom.value;
    $( '.zoom-button' ).prop( 'disabled', false );
    
    if( $( this ).hasClass( 'zoom-in' ) ) {
      zoom.value = zoom.value + zoom.step;
    } else {
      zoom.value = zoom.value - zoom.step;
    }
    if (zoom.value > zoom.max) {
      $( '.zoom-in' ).prop( 'disabled', true );
    } else if ( zoom.value == zoom.min ) {
      $( '.zoom-out' ).prop( 'disabled', true );
    } 

    changeZoom( zoom.value - oldZoom, event );
  }

  function changeZoom( zoomDelta, event ) {
    let scale = props('scaleX');
    let x = props('x');
    let y = props('y');
    
    let rect = container.getBoundingClientRect();  
    let globalX = event.clientX - rect.right;
    let globalY = event.clientY - rect.top;
    
    let localX = (globalX - x) / scale;
    let localY = (globalY - y) / scale;
      
    x += -(localX * zoomDelta);
    y += -(localY * zoomDelta);
    
    gsap.set(image, {
      scale: zoom.value,
      x: x,
      y: y,
    });
    
    setBounds();
  }

  function setBounds() {
    
    let dx = containerWidth  - (imageWidth  * zoom.value);
    let dy = containerHeight - (imageHeight * zoom.value);
    
    let width  = containerWidth  - dx * 2;
    let height = containerHeight - dy * 2;
    
    draggable.applyBounds({    
      left: dx,
      top: dy,
      width: width,
      height: height
    });
  }

  function resize() {
    containerWidth = image.width;
    containerHeight = image.height;
    imageWidth  = containerWidth;
    imageHeight = containerHeight;
  }
}

// this does the zoom on click transition on the cpt cards 
// if they're a quick possession
let enlargeInit = () => {
  let img, image, scrollTop, top, left, width, height, x, y, scale;
  let windowHeight = window.innerHeight;
  let windowWidth = window.innerWidth;

  let enlargePosition = ( elem ) => {
    scrollTop = $( window ).scrollTop();
    top = elem.offset().top;
    left = elem.offset().left;
    width = elem.width();
    height = elem.height();
    x = windowWidth / 2 -  width / 2 - left;
    y = windowHeight / 2 -  height / 2 - top + scrollTop;  

    if( windowHeight / height > windowWidth / width ){
      scale = windowWidth / width * 0.9;
    } else {
      scale = windowHeight / height * 0.875;
    }
  }

  let enlargeTranslate = ( elem ) => {  
    
    if( ! elem.hasClass( 'enlarge' ) ) { 
      openImage( elem )
    } else {
      closeImage();
    }
  };

  let openImage = ( elem ) => {
    $( elem ).parent( '.caption-wrapper' ).addClass( 'enlarge' );
    $( 'body' ).addClass( 'no-scroll' )
    elem.addClass( 'enlarge' ).css({
      'translate' : x + 'px ' + y + 'px',
      'scale' : scale,
    }); 
  }

  let closeImage = () => {
    $( 'body' ).removeClass( 'no-scroll' )
    $( '.caption-wrapper' ).removeClass( 'enlarge' );
    $( '.image-enlarge' ).removeClass( 'enlarge' ).css({
      'translate' : '0px 0px',
      'scale' : '1',

    }); 
  }
  
  let enlarge = ( elem ) => { 
    img = elem;
    image = $( img.currentTarget );
    
    enlargePosition( image );
    enlargeTranslate( image );
  }

  let resize = ( ) => {
    windowHeight = window.innerHeight;
    windowWidth = window.innerWidth;
    image = $( img.currentTarget );
    closeImage( image )
  }

  window.addEventListener( 'resize', resize );

  $( '.image-enlarge' ).on( 'click', enlarge );

  $( '.caption-bg' ).on( 'click', closeImage );
};

$( () => {
  if( $( '.zoom-image-container' ).length ) {
    zoomInit();
  }
  // if( $( '.image-enlarge' ).length ) {
  //   enlargeInit();
  // }
})